import { useTranslation } from 'react-i18next'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { api } from '../../utils/api'
import { ContentType } from '../../utils/api/tools'
import { GET_RELATIVE_SCG, useGetEClaimById, CREATE_USER_CLAIM } from '../e-claim/e-claim-query'
import { CreateEclaimUserResponse, RelativeScgResponse } from '../e-claim/e-claim-types'
import { GET_USER_COIN_URL } from '../user/user-query'
import { OPDHistoryListResponse, OpdListResponse } from '../opd/opd-types'
import { E_CLAIM_LIST, E_CLAIM_BY_ID } from '../e-claim/e-claim-query'
import { WorkOutPlaceResponse, CreateExerciseUser } from './exercise-types'

const APP = '/app'
export const USER_CLAIM = 'userClaim'
export const CHECK_CLAIM_AMOUNT = `${APP}/${USER_CLAIM}/claimableAmount/OPD`
export const CREATE_OPD_CLAIM = `${APP}/${USER_CLAIM}/createUserClaim/OPD`
export const EXERCISE_HISTORY_LIST = `${APP}/${USER_CLAIM}/getAllUserClaimByUser`
export const WORK_OUT_PLACES = `/api/master-data/work-out-places`

// export const useGetExerciseById = (props: GetEClaimByIdProps) => {
//   const { claimId } = props

//   return useQuery([E_CLAIM_BY_ID, claimId], () => {
//     return api.belive.get<EClaimItem>(`${E_CLAIM_BY_ID}/${claimId}`)
//   })
// }
export const useGetExerciseById = useGetEClaimById

export const useGetExerciseList = (groupName = 'exercise') => {
  return useQuery<OpdListResponse>([E_CLAIM_LIST, groupName], () => {
    return api.belive.get<OpdListResponse>(`${E_CLAIM_LIST}?claimTypeGroupName=${groupName}`)
  })
}

export const useCreateExerciseClaim = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (data: CreateExerciseUser) => {
      const {
        claimId,
        receiptAmount,
        receiptDate,
        relativeId,
        consentDate,
        consentBy,
        userClaimDocumentList,
        receiptNo,
        workOutPlaceId,
      } = data
      return api.belive.post<CreateEclaimUserResponse>(
        CREATE_USER_CLAIM,
        JSON.stringify({
          claimId,
          receiptAmount,
          receiptDate,
          relativeId,
          consentDate,
          consentBy,
          userClaimDocumentList,
          receiptNo,
          workOutPlaceId,
        }),
        { contentType: ContentType.JSON },
      )
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([E_CLAIM_LIST])
        queryClient.invalidateQueries([E_CLAIM_BY_ID])
        queryClient.invalidateQueries([EXERCISE_HISTORY_LIST])
        queryClient.invalidateQueries([GET_USER_COIN_URL])
      },
      onError: (e: any) => {
        if (e.message) {
          console.log(e.message)
        }
      },
    },
  )
}

export const useGetExerciseHistoryList = (groupCode = 'exercise') => {
  return useQuery([EXERCISE_HISTORY_LIST, groupCode], () => {
    return api.belive.get<OPDHistoryListResponse>(`${EXERCISE_HISTORY_LIST}?claimTypeGroupCode=${groupCode}`)
  })
}

export const useGetRelativeOption = (claimId?: number) => {
  return useQuery([GET_RELATIVE_SCG, 'options', claimId], async () => {
    const data = await api.belive.get<RelativeScgResponse>(`${GET_RELATIVE_SCG}/opd/${claimId}`)
    const optionRelative: {
      label: string
      value: Record<string, string>
      disabled?: boolean
    }[] = []

    data.map((relative) => {
      const { firstname, lastname, id, typeId, typeName } = relative
      optionRelative.push({
        label: `${typeName}: ${firstname} ${lastname}`, value: {
          id: id.toString(),
          typeId: typeId.toString(),
        }
      })
    })
    // }

    return optionRelative
  })
}

export const useWorkOutPlaceOption = () => {
  return useQuery([WORK_OUT_PLACES], () => {
    return api.belive.get<WorkOutPlaceResponse>(WORK_OUT_PLACES)
  })
}